import React from 'react'
import MNWaterfallApi from 'component/waterfall/masonryApi'
import request from 'meinian-package/src/utils/request'
import Style from '../../../intellectRecommend/recommendCard/style'

export default ({ tabMoveInspirationParams, info }) => {
  const onUninterested = async (curData) => {
    await request.post('/zhikuan/mn/recommend/save-user-uninterested-image', {
      blogId: curData.imageGroupEntityId,
      platformId: curData.platformId
    })
  }
  return <div style={{ marginTop: '24px' }}>
    <MNWaterfallApi
      renderItem={Style}
      gutter={16}
      cardProps={{ allStyleFlag: true, onUninterested }} // allStyleFlag 区别于灵感集的硬编码
      url="/zhikuan/mn/recommend/list-blog-by-inspiration"
      method="spost"
      params={{
        inspirationId: info.id,
        platformId: tabMoveInspirationParams.cardType
      }}
    />
  </div>
}
